<script setup>
import { computed } from 'vue';
import ReportMetricCard from './ReportMetricCard.vue';

const props = defineProps({
  metrics: {
    type: Object,
    required: true,
  },
  formatCurrency: {
    type: Function,
    required: true,
  },
});

const totalItems = computed(() => (props.metrics.totalItems || 0).toLocaleString());
const totalValue = computed(() => props.formatCurrency(props.metrics.totalValue || 0));
const totalContacts = computed(() => (props.metrics.contactMetrics?.totalContacts || 0).toLocaleString());
const totalConversations = computed(() => (props.metrics.activityMetrics?.itemsWithConversations || 0).toLocaleString());
const avgValue = computed(() => props.formatCurrency(props.metrics.averageValue || 0));
const itemsCreatedToday = computed(() => (props.metrics.stageMetrics?.itemsCreatedToday || 0).toLocaleString());
const itemsCreatedThisWeek = computed(() => (props.metrics.stageMetrics?.itemsCreatedThisWeek || 0).toLocaleString());
const itemsCreatedThisMonth = computed(() => (props.metrics.stageMetrics?.itemsCreatedThisMonth || 0).toLocaleString());
const totalOffers = computed(() => (props.metrics.stageMetrics?.totalOffers || 0).toLocaleString());
const avgOffersValue = computed(() => props.formatCurrency(props.metrics.stageMetrics?.avgOffersValue || 0));
const itemsWithChecklists = computed(() => (props.metrics.checklistMetrics?.itemsWithChecklists || 0).toLocaleString());
const checklistCompletionRate = computed(() => `${((props.metrics.checklistMetrics?.completionRate || 0) * 100).toFixed(1)}%`);
const itemsWithDeadline = computed(() => (props.metrics.stageMetrics?.itemsWithDeadline || 0).toLocaleString());
const itemsWithAttachments = computed(() => (props.metrics.activityMetrics?.itemsWithAttachments || 0).toLocaleString());
const itemsWithNotes = computed(() => (props.metrics.activityMetrics?.itemsWithNotes || 0).toLocaleString());
const itemsWithRescheduling = computed(() => (props.metrics.stageMetrics?.itemsWithRescheduling || 0).toLocaleString());
const itemsWithOffers = computed(() => (props.metrics.stageMetrics?.itemsWithOffers || 0).toLocaleString());
const avgActivitiesPerItem = computed(() => (props.metrics.activityMetrics?.averageActivitiesPerItem || 0).toLocaleString());
</script>

<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 mx-0 shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2 px-8 py-8">
    <ReportMetricCard
      :label="'Itens Totais'"
      :value="totalItems"
      info-text=""
    />
    <ReportMetricCard
      :label="'Valor Total'"
      :value="totalValue"
      info-text=""
    />
    <ReportMetricCard
      :label="'Valor Médio'"
      :value="avgValue"
      info-text=""
    />
    <ReportMetricCard
      :label="'Itens Criados Hoje'"
      :value="itemsCreatedToday"
      info-text=""
    />
    <ReportMetricCard
      :label="'Itens Criados na Semana'"
      :value="itemsCreatedThisWeek"
      info-text=""
    />
    <ReportMetricCard
      :label="'Itens Criados no Mês'"
      :value="itemsCreatedThisMonth"
      info-text=""
    />
    <ReportMetricCard
      :label="'Total de Ofertas'"
      :value="totalOffers"
      info-text=""
    />
    <ReportMetricCard
      :label="'Valor Médio das Ofertas'"
      :value="avgOffersValue"
      info-text=""
    />
    <ReportMetricCard
      :label="'Cards com Checklist'"
      :value="itemsWithChecklists"
      info-text=""
    />
    <ReportMetricCard
      :label="'Taxa de Conclusão de Checklist'"
      :value="checklistCompletionRate"
      info-text=""
    />
    <ReportMetricCard
      :label="'Cards com Deadline'"
      :value="itemsWithDeadline"
      info-text=""
    />
    <ReportMetricCard
      :label="'Cards com Anexos'"
      :value="itemsWithAttachments"
      info-text=""
    />
    <ReportMetricCard
      :label="'Cards com Notas'"
      :value="itemsWithNotes"
      info-text=""
    />
    <ReportMetricCard
      :label="'Cards com Conversa'"
      :value="itemsWithConversations"
      info-text=""
    />
    <ReportMetricCard
      :label="'Cards com Reagendamento'"
      :value="itemsWithRescheduling"
      info-text=""
    />
    <ReportMetricCard
      :label="'Cards com Ofertas'"
      :value="itemsWithOffers"
      info-text=""
    />
    <ReportMetricCard
      :label="'Média de Atividades por Item'"
      :value="avgActivitiesPerItem"
      info-text=""
    />
    <ReportMetricCard
      :label="'Total de Contatos'"
      :value="totalContacts"
      info-text=""
    />
    <ReportMetricCard
      :label="'Conversas'"
      :value="totalConversations"
      info-text=""
    />
  </div>
</template> 